export default "__VITE_ASSET__sEChjx$E__"